import { configureEcho } from "@laravel/echo-react";
import keycloak from "@/keycloak";

export function configureEchoForToken() {
  configureEcho({
    broadcaster: "reverb",
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPath: import.meta.env.VITE_REVERB_WS_PATH,
    wsPort: import.meta.env.VITE_REVERB_WS_PORT,
    wssPort: import.meta.env.VITE_REVERB_WSS_PORT,
    forceTLS: import.meta.env.VITE_REVERB_SCHEME === "https",
    enabledTransports: ["ws", "wss"],
    authEndpoint: `${import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT}/api/v1/broadcasting/auth`,
    // headersProvider is invoked fresh on every channel-auth request (subscribe
    // and reconnect), unlike `auth.headers` which pusher-js bakes in once at
    // construction time. This keeps the token valid across Keycloak refreshes,
    // which can otherwise lag behind in backgrounded tabs.
    channelAuthorization: {
      transport: "ajax",
      endpoint: `${import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT}/api/v1/broadcasting/auth`,
      headersProvider: () => ({
        Authorization: `Bearer ${keycloak.token}`,
        Accept: "application/json",
      }),
    },
  });
}